import React from 'react';
import { faArrowLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AddRoad } from '@mui/icons-material';
import { useLocation, useNavigate } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import CustomToastContainer from '../components/CustomToastContainer';

export default function CompleteRoutes() {
  const location = useLocation();
  const navigate = useNavigate();
  var data = location.state;
  var subRoutes = data.item.vehicle_routes;
  var title = data.item.user_readable_name;
  
  const handleNavigation = (path) => {
    navigate(path);
  };


  return (
    <>
      <div className="bg-gray-100 h-screen">
        <nav className="flex items-center justify-between p-2 sm:p-4 bg-white shadow-md">
          <button className="text-gray-600 items-center" onClick={() => handleNavigation(-1)}>
            <FontAwesomeIcon icon={faArrowLeft} size="lg" />
          </button>

          <div className="flex items-center justify-center flex-grow gap-2">
            <h1 className="text-gray-600 font-semibold text-lg">
             {title}
            </h1>
          </div>
        </nav>
            

        <ul className="list-none p-2">
          {subRoutes && subRoutes.map((item, index) => (
              <li 
                  key={item.id} 
                  className="bg-gray-200 my-2 p-4 rounded-md flex items-center"
                  onClick={()=>{navigate('/reserveSeats', { state: {subRoute: item} })}}
              >
                <AddRoad className='text-[#BE1F18] mr-2'/>
                <span className="flex-1 ">{item.user_readable_name}</span>
                <FontAwesomeIcon
                  icon={faChevronRight}
                  className="text-[#111111]"
                />
              </li>
          ))}
        </ul>
      </div>
      <CustomToastContainer/>
    </>
  );
}
